import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from "../../../Baseurl";
import AdminSidebar from "../../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../../component/AdminComp/AdminTopbar";
import CategoryNavbar from "../AdminComp/CategoryNavbar";
import Swal from "sweetalert2";

const TenLevelMenu = () => {
  const [menus, setMenus] = useState([]);
  const [mainCategories, setMainCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [subSubCategories, setSubSubCategories] = useState([]);
  const [subSubSubCategories, setSubSubSubCategories] = useState([]);
  const [finalCategories, setFinalCategories] = useState([]);
  const [sixCategories, setSixCategories] = useState([]);
  const [seventhCategories, setSeventhCategories] = useState([]);
  const [eightCategories, setEightCategories] = useState([]);
  const [nineCategories, setNineCategories] = useState([]);
  
 

  const [selectedMainCategory, setSelectedMainCategory] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [selectedSubSubCategory, setSelectedSubSubCategory] = useState("");
  const [selectedSubSubSubCategory, setSelectedSubSubSubCategory] = useState("");
  const [selectedFinalCategory, setSelectedFinalCategory] = useState("");
  const [selectedSixCategory, setSelectedSixCategory] = useState("");
  const [selectedSeventhCategory, setSelectedSeventhCategory] = useState("");
  const [selectedEightCategory, setSelectedEightCategory] = useState("");
  const [selectedNineCategory, setSelectedNineCategory] = useState("");
  
  const [title, setTitle] = useState("");
  const [position, setPosition] = useState(0);
  const [isCategory, setIsCategory] = useState(false);
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);





  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    if (title.length > 0) {
      fetchSuggestions(title);
    } else {
      setSuggestions([]); // Clear dropdown when input is empty
    }
  }, [title, selectedMainCategory]); // Added selectedMainCategory as a dependency
  

  const fetchSuggestions = async (query) => {
    try {
      const categoryId = selectedMainCategory || "";
      
      // Log the data being sent
      console.log("Fetching suggestions with:", { search: query, category_id: categoryId });
  
      const response = await axios.get(
        `${baseurl}getMenuSuggestions?search=${query}&category_id=${categoryId}`
      );
  
      if (response.data.length > 0) {
        setSuggestions(response.data);
      } else {
        setSuggestions([]);
      }
    } catch (error) {
      setSuggestions([]);
      console.error("Error fetching suggestions:", error);
    }
  };
  
  const handleSelectCategory = (category) => {
    // setTitle(category);
    setSuggestions([]);  
  };




// Fetch Menus
useEffect(() => {
    axios
      .get(`${baseurl}getMenus`)
      .then((response) => {
        setMenus(response.data);
        setMainCategories(response.data.filter(menu => menu.parent_id === null));
      })
      .catch((error) => console.error("Error fetching menus:", error));
  }, []);
  
  // Handle dropdown changes
  const handleMainCategoryChange = (e) => {
    const selectedId = parseInt(e.target.value);
    setSelectedMainCategory(selectedId);
    setSubCategories(menus.filter(menu => menu.parent_id === selectedId));
  
    // Reset all lower-level categories
    setSelectedSubCategory("");
    setSubSubCategories([]);
    setSelectedSubSubCategory("");
    setSubSubSubCategories([]);
    setSelectedSubSubSubCategory("");
    setFinalCategories([]);
    setSelectedFinalCategory("");
    setSixCategories([]);
    setSelectedSixCategory("");
    setSeventhCategories([]);
    setSelectedSeventhCategory("");
    setEightCategories([]);
    setSelectedEightCategory("");
    setNineCategories([]);
    setSelectedNineCategory("");
  };
  
  const handleSubCategoryChange = (e) => {
    const selectedId = parseInt(e.target.value);
    setSelectedSubCategory(selectedId);
    setSubSubCategories(menus.filter(menu => menu.parent_id === selectedId));
  
    // Reset lower categories
    setSelectedSubSubCategory("");
    setSubSubSubCategories([]);
    setSelectedSubSubSubCategory("");
    setFinalCategories([]);
    setSelectedFinalCategory("");
    setSixCategories([]);
    setSelectedSixCategory("");
    setSeventhCategories([]);
    setSelectedSeventhCategory("");
    setEightCategories([]);
    setSelectedEightCategory("");
    setNineCategories([]);
    setSelectedNineCategory("");
  };
  
  const handleSubSubCategoryChange = (e) => {
    const selectedId = parseInt(e.target.value);
    setSelectedSubSubCategory(selectedId);
    setSubSubSubCategories(menus.filter(menu => menu.parent_id === selectedId));
  
    // Reset lower categories
    setSelectedSubSubSubCategory("");
    setFinalCategories([]);
    setSelectedFinalCategory("");
    setSixCategories([]);
    setSelectedSixCategory("");
    setSeventhCategories([]);
    setSelectedSeventhCategory("");
    setEightCategories([]);
    setSelectedEightCategory("");
    setNineCategories([]);
    setSelectedNineCategory("");
  };
  
  const handleSubSubSubCategoryChange = (e) => {
    const selectedId = parseInt(e.target.value);
    setSelectedSubSubSubCategory(selectedId);
    setFinalCategories(menus.filter(menu => menu.parent_id === selectedId));
  
    // Reset lower categories
    setSelectedFinalCategory("");
    setSixCategories([]);
    setSelectedSixCategory("");
    setSeventhCategories([]);
    setSelectedSeventhCategory("");
    setEightCategories([]);
    setSelectedEightCategory("");
    setNineCategories([]);
    setSelectedNineCategory("");
  };
  
  const handleFinalCategoryChange = (e) => {
    const selectedId = parseInt(e.target.value);
    setSelectedFinalCategory(selectedId);
    setSixCategories(menus.filter(menu => menu.parent_id === selectedId));
  
    // Reset 6th, 7th, 8th, and 9th level categories
    setSelectedSixCategory("");
    setSeventhCategories([]);
    setSelectedSeventhCategory("");
    setEightCategories([]);
    setSelectedEightCategory("");
    setNineCategories([]);
    setSelectedNineCategory("");
  };
  
  const handleSixCategoryChange = (e) => {
    const selectedId = parseInt(e.target.value);
    setSelectedSixCategory(selectedId);
    setSeventhCategories(menus.filter(menu => menu.parent_id === selectedId));
  
    // Reset 7th, 8th, and 9th level categories
    setSelectedSeventhCategory("");
    setEightCategories([]);
    setSelectedEightCategory("");
    setNineCategories([]);
    setSelectedNineCategory("");
  };
  
  const handleSeventhCategoryChange = (e) => {
    const selectedId = parseInt(e.target.value);
    setSelectedSeventhCategory(selectedId);
    setEightCategories(menus.filter(menu => menu.parent_id === selectedId));
  
    // Reset 8th and 9th level categories
    setSelectedEightCategory("");
    setNineCategories([]);
    setSelectedNineCategory("");
  };
  
  const handleEightCategoryChange = (e) => {
    const selectedId = parseInt(e.target.value);
    setSelectedEightCategory(selectedId);
    setNineCategories(menus.filter(menu => menu.parent_id === selectedId));
  
    // Reset 9th level category
    setSelectedNineCategory("");
  };
  
  const handleNineCategoryChange = (e) => {
    const selectedId = parseInt(e.target.value);
    setSelectedNineCategory(selectedId);
  };

  

//   const handleFinalCategoryChange = (e) => {
//     setSelectedFinalCategory(parseInt(e.target.value));
//   };

  // Handle Image Upload
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  // Handle Form Submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("title", title);
      formData.append(
        "parent_id",
        selectedNineCategory ||
        selectedEightCategory ||
        selectedSeventhCategory ||
        selectedSixCategory ||
        selectedFinalCategory ||
          selectedSubSubSubCategory ||
          selectedSubSubCategory ||
          selectedSubCategory ||
          selectedMainCategory ||
          null
      );
      formData.append("position", parseInt(position));
      formData.append("is_category", 'true');
      if (image) formData.append("image", image);
  
      console.log("Sending Form Data:");
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }
  
      const response = await axios.post(`${baseurl}addMenuWithImage`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
  
      console.log("Server Response:", response.data);
  
      // Show success message
      Swal.fire({
        title: "Success!",
        text: "Menu item added successfully!",
        icon: "success",
        confirmButtonText: "OK",
      }).then(() => {
        window.location.reload(); // Reload page on OK
      });
  
      // Refresh Menus
      axios.get(`${baseurl}getMenus`).then((response) => {
        setMenus(response.data);
        setMainCategories(response.data.filter((menu) => menu.parent_id === null));
      });
  
      // Reset Form
      setTitle("");
      setSelectedMainCategory("");
      setSelectedSubCategory("");
      setSelectedSubSubCategory("");
      setSelectedSubSubSubCategory("");
      setSelectedFinalCategory("");
      setPosition(0);
      setIsCategory(false);
      setImage(null);
      setPreview(null);
    } catch (error) {
      console.error("Error adding menu:", error);
  
      // Handle duplicate record error
    if (
     error.response?.status === 400 &&
     (error.response.data.message === "No new titles were inserted (all were duplicates)" ||
       error.response.data.message === 'Duplicate title found')
   ) {
     Swal.fire({
       title: "Duplicate Record!",
       text: "A menu item with this title already exists.",
       icon: "warning",
       confirmButtonText: "OK",
     });
   }else {
        // Show generic error alert
        Swal.fire({
          title: "Error!",
          text: "Failed to add menu item. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    }
  };
  



  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />

      {/* Content area */}
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid">
          <CategoryNavbar />

          <div className="crd1">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h4 className="text-start">Add 10th Level Menu</h4>
            </div>

            <form onSubmit={handleSubmit} className="row g-2 text-start">
              

              {/* Main Category */}
              <div className="col-md-8">
                <label className="form-label">Item Category</label>
                <select className="form-select" value={selectedMainCategory} onChange={handleMainCategoryChange}>
                  <option value="">Select Main Category</option>
                  {mainCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
                </select>
              </div>

              {/* Other dropdowns (Sub Categories) */}
              {/* {subCategories.length > 0 && ( */}
                <div className="col-md-8">
                  <label className="form-label">Sub Category</label>
                  <select className="form-select" value={selectedSubCategory} onChange={handleSubCategoryChange}>
                    <option value="">Select Sub Category</option>
                    {subCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
                  </select>
                </div>
              {/* )} */}

 {/* Sub-Sub Category */}
      {/* {subSubCategories.length > 0 && ( */}
        <div className="col-md-8">
          <label className="form-label">Make/Brand</label>
          <select className="form-select" value={selectedSubSubCategory} onChange={handleSubSubCategoryChange}>
            <option value="">Select Sub-Sub Category</option>
            {subSubCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
          </select>
        </div>
      {/* )} */}

      {/* Sub-Sub-Sub Category */}
      {/* Sub-Sub-Sub Category */}
      {/* {subSubSubCategories.length > 0 && ( */}
          <div className="col-md-8">
            <label className="form-label">Instrument Type</label>
            <select className="form-select" value={selectedSubSubSubCategory} onChange={handleSubSubSubCategoryChange}>
              <option value="">Select Instrument Type</option>
              {subSubSubCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
            </select>
          </div>
        {/* )} */}

        {/* Final Category */}
 {/* Final Category */}
<div className="col-md-8">
  <label className="form-label">Final Category</label>
  <select className="form-select" value={selectedFinalCategory} onChange={handleFinalCategoryChange}>
    <option value="">Select Final Category</option>
    {finalCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
  </select>
</div>

{/* 6th Level Category */}
<div className="col-md-8">
  <label className="form-label">6th Level Category</label>
  <select className="form-select" value={selectedSixCategory} onChange={handleSixCategoryChange}>
    <option value="">Select 6th Level Category</option>
    {sixCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
  </select>
</div>

{/* 7th Level Category */}
<div className="col-md-8">
  <label className="form-label">7th Level Category</label>
  <select className="form-select" value={selectedSeventhCategory} onChange={handleSeventhCategoryChange}>
    <option value="">Select 7th Level Category</option>
    {seventhCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
  </select>
</div>

{/* 8th Level Category */}
<div className="col-md-8">
  <label className="form-label">8th Level Category</label>
  <select className="form-select" value={selectedEightCategory} onChange={handleEightCategoryChange}>
    <option value="">Select 8th Level Category</option>
    {eightCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
  </select>
</div>

{/* 9th Level Category */}
<div className="col-md-8">
  <label className="form-label">9th Level Category</label>
  <select className="form-select" value={selectedNineCategory} onChange={handleNineCategoryChange}>
    <option value="">Select 9th Level Category</option>
    {nineCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
  </select>
</div>



{/* Title */}
<div className="col-md-8">
                <label className="form-label">Enter Modal Numbers</label>
                <input type="text" className="form-control" placeholder="Eg. Business & Industrial" value={title || ''} onChange={(e) => setTitle(e.target.value)} required />
              
              
              {/* Dropdown Suggestions */}
              {suggestions.map((category, index) => (
  <li
    key={index}
    className="list-group-item list-group-item-action listcls"
    onClick={() => handleSelectCategory(category.title)}  // Ensure only title is passed
    style={{ cursor: "pointer" }} 
  >
   {index+1}. {category.title}  
   {category.status === "active" ? (
  <span className="text-success">&nbsp; :[Active Category]</span>
) : category.status === "inactive" ? (
  <span className="text-danger">&nbsp;:[Inactive/Trash Category]</span>
) : (
  <small className="text-danger">&nbsp;:[Already Exists]</small>
)}


  </li>
))}
</div>


{/* <div className="col-md-8">
  <label className="form-label">Is Category</label>
  <div className="form-check">
    <input 
      type="checkbox" 
      className="form-check-input" 
      id="isCategory" 
      checked={isCategory} 
      onChange={(e) => setIsCategory(e.target.checked)} 
    />
    <label className="form-check-label" htmlFor="isCategory">
      Yes
    </label>
  </div>
</div> */}





              {/* Image Upload */}
              <div className="col-md-8">
                <label className="form-label">Upload Image</label>
                <input type="file" className="form-control" accept="image/*" onChange={handleImageChange} />
                {preview && <img src={preview} alt="Preview" className="img-thumbnail mt-2" style={{ width: "100px", height: "100px" }} />}
              </div>



              <div className="col-12 text-end">
                <button type="submit" className="btn submitbtnn">Add Menu</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TenLevelMenu;
